module.exports = __webpack_public_path__ + "a13cbf1a4486aa15d9f1e77481047e62.png";